module.exports = __webpack_public_path__ + "img/27.1c97e437.jpg";